export default { baseURL: 'https://dev.regionsanmartin.gob.pe' }
// http://localhost:8081
// https://dev.regionsanmartin.gob.pe
